import { Link } from "react-router-dom";
import { Users, Heart, Star, Mail, MapPin } from "lucide-react";
import brandLogo from "../Assets/karanki-new-logo.jpg";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-ink-900 pt-14 pb-app-nav text-white sm:pb-14">
      <div className="page-container">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={brandLogo}
                alt="Karanki"
                className="h-12 w-12 rounded-2xl object-cover ring-1 ring-white/15 shadow-soft"
              />
              <div className="leading-tight">
                <p className="font-display text-lg font-bold">Karanki</p>
                <p className="text-[11px] tracking-wider text-white/60">MATRIMONY</p>
              </div>
            </div>
            <p className="mt-4 text-[13.5px] leading-7 text-white/70">
              Trusted Telugu matrimony platform specialising in Goud community matchmaking since 2020.
            </p>
          </div>

          <div>
            <h4 className="font-display text-[15px] font-bold">Quick links</h4>
            <ul className="mt-4 space-y-2 text-[13.5px] text-white/70">
              <li><Link to="/register" className="hover:text-white">Register</Link></li>
              <li><Link to="/login" className="hover:text-white">Login</Link></li>
              <li><Link to="/matches" className="hover:text-white">Browse Matches</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/settings" className="hover:text-white">Settings</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-[15px] font-bold">Legal</h4>
            <ul className="mt-4 space-y-2 text-[13.5px] text-white/70">
              <li><Link to="/about-us" className="hover:text-white">About Us</Link></li>
              <li><Link to="/contact-us" className="hover:text-white">Contact Us</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="hover:text-white">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy" className="hover:text-white">Refund Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-[15px] font-bold">Get in touch</h4>
            <ul className="mt-4 space-y-3 text-[13.5px] text-white/70">
              <li className="flex items-center gap-2"><Mail size={14} /> karankimatrimony2020@gmail.com</li>
              <li className="flex items-center gap-2"><MapPin size={14} /> Hyderabad, Telangana</li>
            </ul>
            <div className="mt-5 flex gap-2">
              {[Users, Heart, Star].map((Icon, i) => (
                <button
                  key={i}
                  type="button"
                  aria-label="social"
                  className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 transition hover:bg-white/20"
                >
                  <Icon size={16} />
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-white/10 pt-6 text-[12.5px] text-white/55 sm:flex-row">
          <p>© {year} Karanki Matrimony. All rights reserved.</p>
          <p>Crafted with love for the Goud community.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
